//This contains the URL base path
import baseDomain from './../config/urls.json';
//This file contains URI or relative path concatenated with above
//import urlConfig from './../config/uris.json';
//Cancelling out the above import as it is being moved to public folder

const urlConfig = {};
Object.assign(urlConfig, window.app_uris);
//delete window reference of URIs after loading to const urlConfig
window.app_uris = null;

/*
* COmmon file to manage URLs
*/
const UrlManager = function(){
 var me = this;
 var actionUrlMap = urlConfig;  

 var PROTOCOL = window.location.protocol + "//";
 PROTOCOL = "https://";

 /*for(var i in actionUrlMap){
  if(actionUrlMap[i] && !actionUrlMap[i].match("http[s]?://+")){
    actionUrlMap[i] = PROTOCOL + actionUrlMap[i]; 
  }
 }*/

 //console.log("actionUrlMap ::" , actionUrlMap);

 var localUrlMap = {
  "PRELOGIN_PAGE":"/",
  "LOGIN_HOME":"/landing",
  "404":"/404"  
 }  
//set url configuartion item to actionUrlMap
 for(var item in localUrlMap){
  if(!actionUrlMap[item]){
    actionUrlMap[item] = localUrlMap[item];
  }  
  }

  let sortedBaseDomain = {};

/*
* VERY IMPORTANT: Sorting based on key length is very important
*/
if(baseDomain){
  let sortedArr = Object.keys(baseDomain).sort((a,b) => b.length - a.length)

  if(sortedArr && sortedArr.length > 0){
    for(let i=0; i < sortedArr.length; i++){
      sortedBaseDomain[sortedArr[i]] = baseDomain[sortedArr[i]];
    }
  }
}


/*
* Function to replace URL with Base Domain
*/
  let replaceBaseUrl=function(url){
    if(sortedBaseDomain){
      for(let i in sortedBaseDomain){
        if(url && ~url.indexOf(i)){
          url = url.replace(i, sortedBaseDomain[i]);
          if(url && !url.match("http[s]?://+")){
            url = PROTOCOL + url;
          }
          return url;
        }
      }
    }
    return url;
  }
  
 return{
  getUrlForAction:function(action){
    if(typeof actionUrlMap[action] === "string"){
      return replaceBaseUrl(actionUrlMap[action]);
    }else{
      return "#";
    }
  },
  getUriForAction:function(action){
    if(typeof actionUrlMap[action] === "string"){
      return actionUrlMap[action];
    }else{
      return "#";
    }
  },
  getDomainForAction:function(action){
    if(action){
      var url = this.getUrlForAction(action);
      if(url && url.length > 0){
        try{
          return url.replace(/http[s]?:\/\//gi,"").split("/")[0];
        }catch(e){}     
      }
    }

    return "";
  }
 }
}();

export default UrlManager;


// WEBPACK FOOTER //
// ./src/model/UrlManager.js